import React from 'react';
import MuiDialog from '@mui/material/Dialog';
import MuiDialogContent from '@mui/material/DialogContent';
import { styled } from '@acko-tech/building-blocks.ui.common';
import Typography from '@/components/common/typography';

import CloseIcon from 'Assets/Icons/close.svg';
import { useRestrictModalNavigation } from '../mobileDrawer/hooks/useRestrictModalNavigation';

import { dialog, closeIcon, label } from './styles';
import { useAppBarUpdate } from '@/hooks/useAppBarUpdate';
import {
    LIGHT_THEME_APPBAR_CONFIG,
    POPUPS_APPBAR_CONFIG,
} from '@/config/appbarConfig';
import { getLastPageAppBarConfig } from '@/utils/webviewHandlers';

interface IDesktopDialogProps {
    show: boolean;
    title?: string;
    hideClose?: boolean;
    className?: string;
    onClose?: () => void;
    children: React.ReactElement | React.ReactElement[];
}

const ExtMuiDialog = styled(MuiDialog)`
    ${dialog};
`;

const ExtCloseIcon = styled(CloseIcon)`
    ${closeIcon};
`;

const Label = styled(Typography)`
    ${label};
`;

const DesktopDialog: React.FC<IDesktopDialogProps> = ({
    show,
    title,
    children,
    hideClose,
    onClose,
    className,
}) => {
    const { handleClose } = useRestrictModalNavigation(show, onClose);
    const modalAppConfig = show
        ? POPUPS_APPBAR_CONFIG
        : getLastPageAppBarConfig() || LIGHT_THEME_APPBAR_CONFIG;

    useAppBarUpdate(modalAppConfig, true, false);

    return (
        <ExtMuiDialog
            open={show}
            PaperProps={{ elevation: 0 }}
            className={className}
        >
            <MuiDialogContent>
                {/* {!hideClose && <ExtCloseIcon onClick={handleClose} />} */}
                <Label variant="h5">{title}</Label>
                {children}
            </MuiDialogContent>
        </ExtMuiDialog>
    );
};

export default DesktopDialog;
